<div [id]="htmlId()" class="item-container multi-column-container" [style.display]="isVisible() ? 'flex' : 'none'">
  <span
    [id]="'first_col_' + htmlId()"
    [title]="properties.text1"
    [ngClass]="['multi-column-text1', properties.styleText1.toLowerCase(), 'preserve-newlines']"
    [ngStyle]="firstColumnStyle()">
    {{ properties.text1 }}
  </span>
  <span
    [id]="'second_col_' + htmlId()"
    [title]="properties.text2"
    [ngClass]="['multi-column-text2', properties.styleText2.toLowerCase(), 'preserve-newlines']">
    {{ properties.text2 }}
  </span>
</div>
